import { onCostCenterActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import CostCenterActivityCard from "./CostCenterActivityCard";

interface Props {
  config: server.dto.ActivityPanelConfig
  itemId: number
}

const CostCenterActivityPanel = (props: Props) => {
  return <ActivityPanel
    activityKey="costCenter"
    itemId={props.itemId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.CostCenter.ListActivity({ page, perPage, itemId: props.itemId })}
    onActivityRegisterFn={onCostCenterActivity}
    onActivity={() => ({ refreshActivities: true })}
    renderActivity={activity => <CostCenterActivityCard key={activity.activityId} activity={activity} />}
  />;
};

export default CostCenterActivityPanel;
